import { useState } from 'react';

function ShowMoreText({ text = '', maxLength, reference = '' }) {
  const [isExpanded, setIsExpanded] = useState(false);

  const shouldTruncate = text.length > maxLength;

  const visibleText = isExpanded ? text : text.slice(0, maxLength);

  return (
    <div className='text'>
      <p>
        {visibleText}
        {reference && ((shouldTruncate && isExpanded) || !shouldTruncate) && (
          <b> (Ref: {reference})</b>
        )}
        {!isExpanded && shouldTruncate && <strong>...</strong>}{' '}
        {shouldTruncate && (
          <button
            onClick={(e) => {
              e.stopPropagation();
              setIsExpanded(!isExpanded);
            }}
            className='show-more'
          >
            {isExpanded ? 'Show less' : 'Show more'}
          </button>
        )}
      </p>
    </div>
  );
}

export default ShowMoreText;
